<ng-container *workspaceView="'full'">
<app-data-table class="workspace-page__panel" [(search)]="collectionSearch" #table [columns]="columns" [fetch]="fetch"
                searchPlaceholder="Site, address or customer"
                columnPickerKey="rolloff-hires-list"
                [resizableColumns]="true"
                [filters]="filterValues"
                [pageSize]="50" [pageSizeOptions]="[25, 50, 100, 200]"
                emptyText="No deal matches those filters.">

  <!-- The board's Filters bar, from the same column list, so a hire is
       narrowed by the same columns in either view. Apply hands the values to
       the table, which reads its first page again under them. -->
  <app-data-filter dt-filters #filter
                   [fields]="filterFields"
                   [values]="filterValues"
                   (change)="filter.apply()"
                   (applied)="applyFilters($event)"></app-data-filter>

  <!-- Rows out, rows in and rows folded, from the one component that owns all
       three, gated the way this table's server gates them. The board carries
       the same component over the same endpoint, so a deal leaves by the same
       file whichever view somebody is looking at. -->
  <app-table-transfer-actions dt-actions table="rolloff-hires" title="roll-off deals"
                              [exportUrl]="exportUrl"
                              exportFileName="rolloff-deals.csv"
                              (changed)="onTransferChanged()"></app-table-transfer-actions>

  <ng-template dtCell="siteName" let-r>
    <button type="button" class="ro-link" (click)="open.emit(r.id)">
      {{ r.siteName || '—' }}
    </button>
  </ng-template>

  <ng-template dtCell="address" let-r>{{ address(r) }}</ng-template>
  <ng-template dtCell="city" let-r>{{ r.city || '—' }}</ng-template>
  <ng-template dtCell="postalCode" let-r>{{ r.postalCode || '—' }}</ng-template>

  <ng-template dtCell="stage" let-r>
    <span class="ro-stage">{{ r.leadStageName }}</span>
  </ng-template>

  <ng-template dtCell="container" let-r>{{ container(r) }}</ng-template>

  <ng-template dtCell="quotedPrice" let-r>
    <span *ngIf="r.quotedPrice != null">{{ r.quotedPrice | currency }}</span>
    <span *ngIf="r.quotedPrice == null" class="br-cell-empty">&#8212;</span>
  </ng-template>

  <ng-template dtCell="hireStartsOn" let-r>
    {{ r.hireStartsOn || '—' }}
  </ng-template>

  <!-- A hire that should have come back and has not is the same glance the
       leads table gives an overdue next action, and is marked the same way. -->
  <ng-template dtCell="hireEndsOn" let-r>
    <span [class.ro-overdue]="overdue(r)">{{ r.hireEndsOn || '—' }}</span>
  </ng-template>

  <ng-template dtCell="salesRep" let-r>
    <span *ngIf="r.salesRepUserId != null">{{ repName(r) }}</span>
    <span *ngIf="r.salesRepUserId == null" class="br-cell-empty">Unassigned</span>
  </ng-template>

  <ng-template dtCell="createdAt" let-r>
    {{ r.createdAt | date:'yyyy-MM-dd' }}
  </ng-template>

</app-data-table>
</ng-container>

<ng-container *workspaceView="'compact'">
    <app-data-list [pageSize]="50" #compactList [fetch]="fetch" [(search)]="collectionSearch">

      <ng-template dataListItem let-row>
        <div class="br-flex br-items-center br-justify-between br-gap-2">
          <strong>{{ row.siteName }}</strong>
          <app-map-pin></app-map-pin>
        </div>
        <div class="br-text-muted">{{ address(row) || 'No address' }}</div>
      </ng-template>
      <ng-template dataListDetail let-row>
        <app-rolloff-hire-detail #detail [inline]="true" [hireId]="row.id"
                                [stages]="stages" [reps]="reps"
                                [canManage]="auth.hasPermission('LeadPipeline.Manage')"
                                (edit)="editCompactHire($event, detail)">
        </app-rolloff-hire-detail>
      </ng-template>
    </app-data-list>
</ng-container>
